import React from 'react'
import { Col, Row } from 'react-bootstrap'

const NotFound = () => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12} style={{ height: '100vh', padding: 0 }}>
          <iframe
            title='Kustomer Portal'
            src='https://onpoint-warranty-serviceavenger.kustomer.help/contact/intake-portal-form-rk5PH5tvWx?hideNav=true'
            width='100%'
            height='100%'
            style={{
              border: 'none',
              background: '#f5f5f5',
            }}
            allowFullScreen
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default NotFound
